// extracted by mini-css-extract-plugin
module.exports = {"blog":"Blog_blog__3z2TL","placeholder":"Blog_placeholder__3nFa5"};